import { Component } from '@angular/core';


@Component({
  selector: 'app-agregar-presolicitud',
  templateUrl: './agregar-presolicitud.component.html',
  styleUrls: ['./agregar-presolicitud.component.css']
})
export class AgregarPresolicitudComponent {
  constructor () {

  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/presolicitudes/agregar-presolicitud/agregar-presolicitud.component.ts